module.exports = __webpack_public_path__ + "img/li.0f6fda67.svg";